import { Action, Module, VuexModule } from "vuex-class-modules";
import { OrganizationStatus, OrganizationType } from "@gsx/common";
import { ICountry, IState } from "../../../../vendor/country-state-city";

@Module({ generateMutationSetters: true })
export class OrganizationFilterStore extends VuexModule {
    productTags: Set<string> = new Set();
    serviceTags: Set<string> = new Set();
    operatingRegimeTags: Set<string> = new Set();
    applicationTags: Set<string> = new Set();
    countries: Set<ICountry["name"]> = new Set();
    states: Set<IState["name"]> = new Set();
    status: OrganizationStatus | null = null;
    organizationType: OrganizationType | null = null;
    manufactureInternal: boolean = false;
    testCapability: boolean = false;
    hiring: boolean = false;
    acquisitionOpportunity: boolean = false;
    logicalOperator: "AND" | "OR" = "AND";
    afterYear: number = 0;
    beforeYear: number = 0;

    @Action
    public toggleCountry(name: string): void {
        const countries = new Set(this.countries.values());

        if (countries.has(name)) {
            countries.delete(name);
        } else {
            countries.add(name);
        }

        this.countries = countries;
    }

    @Action
    public toggleState(name: IState["name"]): void {
        const states = new Set(this.states.values());

        if (states.has(name)) {
            states.delete(name);
        } else {
            states.add(name);
        }

        this.states = states;
    }

    @Action
    public toggleProduct(name: string): void {
        const newTags = new Set(this.productTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.productTags = newTags;
    }

    @Action
    public toggleService(name: string): void {
        const newTags = new Set(this.serviceTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.serviceTags = newTags;
    }

    @Action
    public toggleOperatingRegime(name: string): void {
        const newTags = new Set(this.operatingRegimeTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.operatingRegimeTags = newTags;
    }

    @Action
    public toggleApplication(name: string): void {
        const newTags = new Set(this.applicationTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.applicationTags = newTags;
    }

    @Action
    public toggleStatus(status: OrganizationStatus): void {
        this.status = this.status === status ? null : status;
    }

    @Action
    public toggleType(type: OrganizationType): void {
        this.organizationType = this.organizationType === type ? null : type;
    }

    @Action
    public resetFilters(): void {
        this.productTags = new Set();
        this.serviceTags = new Set();
        this.applicationTags = new Set();
        this.operatingRegimeTags = new Set();
        this.countries = new Set();
        this.states = new Set();
        this.status = null;
        this.organizationType = null;
        this.manufactureInternal = false;
        this.testCapability = false;
        this.hiring = false;
        this.acquisitionOpportunity = false;
        this.afterYear = 0;
        this.beforeYear = 0;
    }
}
